export function getCategory(state) {
  return state.category.list || {};
}
